import { subYears } from 'date-fns'

export type UseBirthdayOptions = { minDate: Date; maxDate: Date }

export const useBirthdayOptions = (): UseBirthdayOptions => {
  const today = new Date()
  const minDate = subYears(today, 100)
  const maxDate = today

  return { minDate, maxDate }
}
